(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/behaviors/handlesubscription.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/behaviors/handlesubscription.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.behaviors.HandleSubscription = Marionette.Behavior.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    channelName: 'start-subscription',
    radioEvents: {
      communicationTypeChanged() {
        this.context.triggerPrefixMethod && this.context.triggerPrefixMethod('isVerified');
      }
    },
    behaviors() {
      const behaviors = [{
        behaviorClass: svs.tur.start_subscription.behaviors.TrackGa
      }];
      if (this.getOption('start')) {
        behaviors.push({
          behaviorClass: svs.tur.start_subscription.behaviors.StartSubscription
        });
      }
      if (this.getOption('change')) {
        behaviors.push({
          behaviorClass: svs.tur.start_subscription.behaviors.ChangeSubscription
        });
      }
      if (this.getOption('enable')) {
        behaviors.push({
          behaviorClass: svs.tur.start_subscription.behaviors.EnableSubscription
        });
      }
      return behaviors;
    },
    onSetActiveContext(context) {
      this.context = context;
    },
    onAutogiroPaymentAccessCreated() {
      this.context.postNewSubscription();
    },
    onShowAutogiroAgreement() {
      const modalView = new svs.tur.start_subscription.views.AutogiroApproval({
        model: this.context.entryModel,
        context: this.context
      }).render().$el;
      svs.components.Modal.show(modalView, null, {
        title: 'Skapa medgivande',
        doubleWidth: true,
        rightButton: {
          visible: false
        },
        leftButton: {
          visible: true,
          text: 'Avbryt',
          callback: () => {
            var _this$context, _this$context$get;
            const cancelUrl = this === null || this === void 0 || (_this$context = this.context) === null || _this$context === void 0 || (_this$context = _this$context.entryModel) === null || _this$context === void 0 || (_this$context$get = _this$context.get) === null || _this$context$get === void 0 ? void 0 : _this$context$get.call(_this$context, 'cancelUrl');
            svs.components.Modal.hide();
            if (cancelUrl) {
              svs.components.loader.show();
              svs.utils.url.navigate(cancelUrl);
            }
          }
        }
      });
    },
    onHandleChangeSubscription(subscriptionId, product) {
      window.location.href = "".concat(this.getProductUrl(product), "/min-prenumeration/").concat(subscriptionId);
    },
    onDeleteSubscription(subscriptionId) {
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'subscription',
        title: 'Avsluta prenumeration',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: 'Du avslutar din prenumeration men är fortfarande med i redan betalade omgångar.',
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: 'Du debiteras inte för ny betalningsperiod.',
          align: svs.ui.dialog.message.align.CENTER
        }],
        actions: [{
          title: 'Avbryt'
        }, {
          title: 'Avsluta',
          callback: () => {
            dialog.close();
            this.view.triggerMethod('subscriptionConfirmCancel', subscriptionId);
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    },
    onSubscriptionConfirmCancel(subscriptionId) {
      svs.tur.start_subscription.radio.request('cancelSubscription', subscriptionId || this.view.model.get('subscriptionId'), this, () => this.view.triggerMethod('subscriptionCancelled', subscriptionId));
    },
    onSubscriptionCancelled(subscriptionId) {
      const title = 'Prenumerationen är avslutad';
      const message = [{
        type: svs.ui.dialog.message.TEXT,
        text: 'Du kan enkelt återaktivera den inom 30 dagar om du ångrar dig. Tack för att du spelat med oss - vi ses igen när du är redo!',
        align: svs.ui.dialog.message.align.CENTER
      }];
      const flashCallback = () => {
        svs.components.loader.show();
        setTimeout(() => {
          window.location.href = "".concat(svs.core.urlMapping.get('myGamingsSubscriptions'), "?deleted=").concat(subscriptionId || this.view.model.get('subscriptionId'));
        }, 3000);
      };
      if (window.location.pathname !== svs.core.urlMapping.get('myGamingsSubscriptions')) {
        svs.core.flash('success', {
          icon: 'thumbs-up',
          title,
          message,
          area: svs.ui.dialog.area.POPUP,
          branding: svs.ui.dialog.branding.TUR
        }, flashCallback);
      } else {
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'thumbs-up',
          title,
          message,
          actions: [{
            title: 'Okej'
          }]
        }));
      }
    },
    getProductUrl(product) {
      product = svs.numbergames.productMapping.getProductId(product);
      switch (product) {
        case 'LOTTO':
          return svs.core.urlMapping.get('lottoHome');
        case 'VIKINGLOTTO':
          return svs.core.urlMapping.get('vikinglottoHome');
        case 'EUROJACKPOT':
          return svs.core.urlMapping.get('eurojackpotHome');
        default:
      }
    }
  });
})(Backbone, _, svs);

 })(window);